import styles from './GroupList.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import {Link} from 'react-router';
import lodash from 'lodash';
import GroupRow from '../GroupRow/GroupRow';
import tableStyles from '../GroupRow/GroupTable.scss';

export default class GroupList extends Component {
    _getGroupPath(group) {
        const path = `/admin/groups/${group.id}`;
        return path;
    }

    _buildGroupList() {
        const { groups } = this.props;

        return lodash.values(groups).map((group, index) =>
            <Link key={index} to={this._getGroupPath(group)} className={tableStyles.tableRow}>
                <GroupRow group={group} />
            </Link>
        );
    }

    render() {
        const groups = this._buildGroupList();
        return (
            <div className={styles.groupContainer} data-cy="GroupList">
                <header className={styles.header}>
                    <span className={styles.title}>
                        Groups
                    </span>
                    <span className={styles.info}>
                        Groups are displayed in order of priority for resolving permissions
                    </span>
                </header>
                <div className={tableStyles.groupsTable} data-cy="GroupList-div">
                    <div className={tableStyles.tableRow + ' ' + tableStyles.tableRowHeader}>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.text}>
                                Name
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.text}>
                                Description
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.searchable}>
                                Is Searchable
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.dts}>
                                Document Types
                            </div>
                        </div>
                        <div className={tableStyles.wrapper}>
                            <div className={tableStyles.users}>
                                Users
                            </div>
                        </div>
                    </div>
                    { groups }
                </div>
            </div>
        );
    }
}

GroupList.propTypes = {
    title: PropTypes.string,
    institutionId: PropTypes.string,
};
